import { Axios } from "../axios";
import PaymentOptionsAPIProps from "./paymentOptions";

export const getBankNames = async (currentUser: PaymentOptionsAPIProps.AuthorisationProps) => {
  if (currentUser) {
    return await Axios.get(`/remit/bank/fetch/net-banks`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const pennyDropAPI = async (body: PaymentOptionsAPIProps.PennyDropAPIProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/bank/pennydrop/razorpay", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const requestRazor = async (body: PaymentOptionsAPIProps.RequestRazorPayProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/bank/payment/requestRazor", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const razorPayResponse = async (body: PaymentOptionsAPIProps.RazorpayResponseProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/bank/payment/razorPayResponse", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const requestRazorLink = async (body: PaymentOptionsAPIProps.RequestRazorPayProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/bank/payment/requestRazorLink", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const fetchNeftBankDetails = async (referrerVendorCode: string, isNeft?: boolean) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`remit/user/${currentUser?.vendor_key}/neftBankDetails`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
      params: {
        referrerVendorCode: referrerVendorCode,
        ad1Transaction: isNeft,
      },
    });
  }
};

export const shareNeftDetails = async (transactionNumber: string) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `remit/user/${currentUser?.vendor_key}/shareAccountDetails/${transactionNumber}`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};

export const fetchingNeftBankDetails = async (referrerVendorCode?: string, isNeft?: boolean) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `remit/user/${currentUser?.vendor_key}/neftBankDetails?ad1Transaction=${isNeft}&referrerVendorCode=${referrerVendorCode}`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      }
    );
  }
};
